var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKontakt2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.668 0C35.446 0 40 4.756 40 11.832V28.168C40 35.244 35.446 40 28.664 40H11.328C4.552 40 0 35.244 0 28.168V11.832C0 4.756 4.552 0 11.328 0H28.668ZM28.668 3H11.328C6.27 3 3 6.466 3 11.832V28.168C3 33.534 6.27 37 11.328 37H28.664C33.728 37 37 33.534 37 28.168V11.832C37 6.466 33.728 3 28.668 3ZM19.988 18.5C20.816 18.5 21.488 19.172 21.488 20V28C21.488 28.828 20.816 29.5 19.988 29.5C19.16 29.5 18.488 28.828 18.488 28V20C18.488 19.172 19.16 18.5 19.988 18.5ZM19.9978 10.4082C21.1038 10.4082 21.9978 11.3022 21.9978 12.4082C21.9978 13.5142 21.1038 14.4082 19.9978 14.4082C18.8918 14.4082 17.9878 13.5142 17.9878 12.4082C17.9878 11.3022 18.8738 10.4082 19.9778 10.4082H19.9978Z",
    fill: "#284591"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKontakt2);
export default __webpack_public_path__ + "static/media/kontakt_2.4107a321aeb2f6acf71ed691b638a385.svg";
export { ForwardRef as ReactComponent };